import './home.css'
import React, { useState,useEffect} from 'react';
import { Card,CardMedia,CardActionArea,CardContent} from '@mui/material';
import {Link} from 'react-router-dom'
import UmbrellaRainAnimation from './UmbrellaRainAnimation';
import LoadFailed from './LoadFailed';
import { div } from 'framer-motion/client';

function Home(){

    const [titleData, setTitleData] = useState([])
    const [opacity, setOpacity] = useState(0);
    const [loading,setLoading] = useState(false)
    const [resultsCount,setResultCount] = useState('')
    
    useEffect(() => {
        getTitleData()
    },[resultsCount]);
    
    useEffect(() => {
        let timer;
        if (loading) {
            setOpacity(0); // 重置透明度为 0
            timer = setTimeout(() => {
                setOpacity(1); // 在 25 秒后设置透明度为 1
            }, 25000); // 25 秒
        }
            return () => clearTimeout(timer); // 清理计时器
    }, [loading]); // 监听 loading 状态
    
    const getTitleData = async () => {
        setLoading(true); // 开始加载
        try {
            const res = await fetch('https://api.sadatsunemyspace.uk/api/randomarctitle', {
                method: 'POST',
                headers: { "Content-Type": "application/x-www-form-urlencoded" },
            });
            const { data } = await res.json();
            setTitleData(data);
        } catch (error) {
            console.error("Error fetching title data:", error);
        } finally {
            setLoading(false); // 加载完成
        }
    };

    return(
       <div>
            <p className='articletitle'>Glad you dropped by! Welcome to my site!</p>
            <p className='nekopara' >This site mainly demonstrates things related to my hobbies and you can view postal datestamps and part of QSLs I collected.
            Also some notes of GIS (Geographic Informtion Science, or Systems) tech field. Here you can see some of my map productions too.
                <br/>Hope you will enjoy it!</p>
            <hr className='divideline'></hr>
            <div className='latestarticles'>
                <p className='titlenewarticles'>Recommended Articles</p>
                <div className='cards'>
                {loading ? (
                <div style={{
                    gridColumn: '1 / -1',
                    display: 'flex',
                    justifyContent: 'center'
                }}>
                <center >
                    <UmbrellaRainAnimation transparent={opacity} />
                </center>
                </div>
                
                ) : (
                titleData.length > 0 ? (
                    titleData.map((title) => (
                    <Link to={title.link} style={{ textDecoration: 'none' }}>
                        <Card className='card' elevation={5} >
                            <CardActionArea>
                                <CardMedia
                                component="img"
                                className='cardimage'
                                image={title.tpic}
                                alt='picture'
                                />
                                <CardContent>
                                    <h5 className='cardtitle' >{title.title}</h5>
                                    <p className='carddetails' >{title.desc}</p>
                                    <p className='carddate' >{title.date}</p>
                                </CardContent>
                            </CardActionArea>
                        </Card>
                    </Link>
                    ))
                ) : (
                    <LoadFailed/>
                )
                )}
                </div>
        </div>
        <center>
                <a href="https://info.flagcounter.com/swfV">
                <img style={{
                    marginTop:'20px',
                    maxWidth:'400px',
                    width:'88%'
                }}src="https://s01.flagcounter.com/count2/swfV/bg_FFFFFF/txt_000000/border_FFFFFF/columns_4/maxflags_16/viewers_0/labels_0/pageviews_1/flags_0/percent_0/" alt="Flag Counter" border="0"/>
            </a>
        </center>
       </div>
    );
}

export default Home;



